import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import Modal from 'src/components/customModal';
import { styledMainTitle } from 'src/components/InviteModal/styles';
import modals from 'src/constants/modals';
import { ActionButtons } from 'src/layouts/main/styles';
import { RHFTextField } from 'src/components';
import { dispatch } from 'src/redux/store';
import { openModal, selectModal } from 'src/redux/slices/modal';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useState } from 'react';
import { QuoteQuestionsForm } from './types';

// Validation Schema
const schema = Yup.object({
	issue: Yup.string()
		.required('This field is required')
		.min(1, 'At least one character is required') // Ensures that at least one char is entered
		.max(100, 'Maximum 100 characters allowed'),
});

const Content = () => {
	const { payload } = useSelector(selectModal<{ issue?: string }>);
	const [inputValue, setInputValue] = useState(payload.issue || '');
	const maxLength = 100;

	const form = useForm<QuoteQuestionsForm>({
		resolver: yupResolver(schema), // Using the Yup schema
		defaultValues: { issue: payload.issue },
	});

	const handleSendMessage = async (data: QuoteQuestionsForm) => {
		dispatch(openModal({ name: modals.quoteMessage, payload: { issue: data.issue } }));
	};
	const handleRequestCallback = async (data: QuoteQuestionsForm) => {
		dispatch(openModal({ name: modals.quoteCallbackRequest, payload: { issue: data.issue } }));
	};
	const handleBookMeeting = async (data: QuoteQuestionsForm) => {
		dispatch(openModal({ name: modals.quoteMeeting, payload: { issue: data.issue } }));
	};

	const handleChange = (e) => {
		setInputValue(e.target.value); // Update the input value state
	};

	return (
		<FormProvider {...form}>
			<Typography sx={styledMainTitle} pt={0}>
				CONTACT OUR TEAM
			</Typography>
			<Typography mb='7px'>
				In a few words, describe your issue so we can connect you with the best person to help.
			</Typography>

			<Controller
				name='issue'
				control={form.control}
				render={({ field, fieldState }) => (
					<>
						<RHFTextField
							{...field}
							label={inputValue ? `${maxLength - inputValue.length} characters left` : 'Describe your issue'}
							sx={{ width: '100%', mt: '10px' }}
							inputProps={{ maxLength }}
							value={inputValue}
							onChange={(e) => {
								handleChange(e); // Update state and react-hook-form value
								field.onChange(e); // Update form value
							}}
							error={!!fieldState?.error} // Pass boolean value to `error`
							helperText={fieldState?.error ? fieldState.error.message : ''} // Show error message
						/>
					</>
				)}
			/>

			<ActionButtons mt='20px'>
				<LoadingButton
					variant='outlined'
					size='large'
					fullWidth
					onClick={form.handleSubmit(handleRequestCallback)}
					sx={{ textTransform: 'unset', whiteSpace: 'nowrap' }}
				>
					Request a callback 📞
				</LoadingButton>
				<LoadingButton
					variant='outlined'
					size='large'
					fullWidth
					sx={{ textTransform: 'unset', whiteSpace: 'nowrap' }}
					onClick={form.handleSubmit(handleBookMeeting)}
				>
					Book a meeting 💻
				</LoadingButton>
				<LoadingButton
					variant='contained'
					size='large'
					fullWidth
					onClick={form.handleSubmit(handleSendMessage)}
					sx={{ textTransform: 'unset', whiteSpace: 'nowrap' }}
				>
					Send a message ✉️
				</LoadingButton>
			</ActionButtons>
		</FormProvider>
	);
};

const QuoteQuestionsModal = () => (
	<Modal name={modals.quoteQuestions} cardSx={{ overflow: 'visible', maxWidth: '750px' }}>
		<Content />
	</Modal>
);

export default QuoteQuestionsModal;
